import { Components, Theme } from '@mui/material/styles';

const muiTableStyles: Components<Omit<Theme, 'components'>> = {
  MuiTableContainer: {
    styleOverrides: {
      root: {}
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: '13px',
        padding: '14px 20px',
        border: '1px solid var(--gray-6)',
        boxShadow: 'none',
        borderCollapse: 'collapse'
      }
    }
  },
  MuiTable: {
    styleOverrides: {
      root: {
        boxShadow: 'none',
        borderCollapse: 'collapse',
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none'
      }
    }
  },
  MuiTableBody: {
    styleOverrides: {
      root: {
        '& td': {
          color: 'var(--dark-1)',
          fontSize: '16px',
          padding: '16px 24px',
          fontWeight: '400',
          maxWidth: '400px !important',
          '@media (max-width: 1715px)': {
            fontSize: '13px !important',
            padding: '10px 16px'
          }
        },
        '& td:not(:first-of-type):not(:last-of-type)': {
          minWidth: '150px'
        }
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        border: '1px solid var(--gray-6)',
        '&:first-of-type': {
          borderLeft: 'none'
        },
        '&:last-of-type': {
          borderRight: 'none'
        },
        '@media (max-width: 1715px)': {
          padding: '10px 16px'
        }
      },
      head: {
        color: 'var(--blue-4)',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: 'normal',
        backgroundColor: 'white',
        borderTop: 'none',
        minWidth: '100px',
        '@media (max-width: 1715px)': {
          fontSize: '13px !important'
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-4px',
          left: 0,
          height: '5px',
          width: '100%',
          backgroundColor: 'white',
          zIndex: 14
        }
      }
    }
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&:nth-of-type(1)': {
          backgroundColor: 'transparent'
        },
        '&:nth-of-type(2n)': {
          backgroundColor: 'rgba(247, 249, 252, 1)'
        },
        '&:last-child td': {
          borderBottom: 'none'
        },
        '&:nth-of-type(2n) td.sticky-action-cell': {
          backgroundColor: 'rgba(247, 249, 252, 1) !important'
        }
      }
    }
  }
};

export default muiTableStyles;
